const DEFAULT_TEXT_STYLE = {
    fontSize: '16px',
    paddingLeft: 16,
    paddingRight: 16,
};

export { DEFAULT_TEXT_STYLE };
